<template>
  <div class="head">
    <img src="@/assets/order/danzi.svg" alt="" />
    <div class="img" v-show="data.state === 'INVALID'">
      <img :src="require('@/assets/mine/已取消.svg')" alt="" />
    </div>
    <div class="body">
      <p class="status">{{ data.state | status_f(inSaleOrderState, data) }}</p>
      <div class="list">
        <div class="cell">
          <p class="label">订单编号</p>
          <p class="value">{{ data.orderNo }}</p>
        </div>

        <div class="cell">
          <p class="label">下单时间</p>
          <p class="value">
            {{ dayjs(data.createTime).format("YYYY-MM-DD HH:mm:ss") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      inSaleOrderState: (state) => state.options.inSaleOrderState,
      returnOrderServerType: (state) => state.options.returnOrderServerType,
    }),
  },
  filters: {
    status_f(val, list, data) {
      const i = list.find((item) => item.value === val);
      if (i && i.label === "待发货" && data.deliverState === "PREPARING") {
        return "备货中";
      }
      return (i && i.label) || "";
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  display: flex;
  align-items: flex-end;
  background: #c82d26;
  padding: 22px 52px 140px;
  .img {
    img {
      width: 132px;
      height: 154px;
    }
  }
  .body {
    flex: 1;
    min-width: 0;
    padding-left: 20px;
  }
  .status {
    font-size: 40px;
    color: #ffffff;
    line-height: 40px;
  }
  .list {
    padding-top: 24px;
    .cell {
      display: flex;
      font-size: 24px;
      color: #ffffff;
      line-height: 24px;
      & + .cell {
        margin-top: 12px;
      }
      .value {
        padding-left: 24px;
      }
    }
  }
}
</style>
